import { useState, useEffect } from 'react';
import { apiFetch } from '../config/api';
import PlatformStatsOverview from '../components/PlatformStatsOverview';
import MasterSearchPanel from '../components/MasterSearchPanel';
import UpcomingCarpoolsPanel from '../components/UpcomingCarpoolsPanel';

const STATUS_CLASS = {
  ACTIVE: 'sa-badge-active',
  INACTIVE: 'sa-badge-inactive',
  TRIAL: 'sa-badge-trial',
  SUSPENDED: 'sa-badge-suspended',
  ARCHIVED: 'sa-badge-inactive',
};

export default function Dashboard({ token, navigate }) {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [upcomingCarpools, setUpcomingCarpools] = useState([]);
  const [upcomingLoading, setUpcomingLoading] = useState(true);
  const [upcomingError, setUpcomingError] = useState('');
  const [upcomingSchoolCount, setUpcomingSchoolCount] = useState(0);

  useEffect(() => {
    apiFetch('/schools/directory', {}, token)
      .then((res) => setSchools(res.data || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    apiFetch('/carpool-schedule/upcoming?days=7&limit=100', {}, token)
      .then((res) => {
        setUpcomingCarpools(res.data || []);
        setUpcomingSchoolCount(Number(res.meta?.school_count) || 0);
      })
      .catch((err) => setUpcomingError(err.message || 'Could not load upcoming carpools.'))
      .finally(() => setUpcomingLoading(false));
  }, [token]);

  if (loading) return <div className="sa-empty">Loading schools...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 24, margin: 0 }}>Schools</h2>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <button className="sa-btn sa-btn-secondary" onClick={() => navigate('server-health')}>
            ♥ Server Health
          </button>
          <button className="sa-btn sa-btn-secondary" onClick={() => navigate('csv-import')}>
            CSV Import
          </button>
          <button className="sa-btn" style={{ background: '#0f766e', color: '#fff' }} onClick={() => navigate('expo-previews')}>
            ▣ Expo Preview Hub
          </button>
          <button className="sa-btn sa-btn-secondary" onClick={() => navigate('carpool-replay')}>
            ⟲ Carpool Replay
          </button>
          <button className="sa-btn" style={{ background: '#7c3aed', color: '#fff' }} onClick={() => navigate('simulate')}>
            ▶ Simulate Dismissal
          </button>
          <button className="sa-btn sa-btn-primary" onClick={() => navigate('school-create')}>
            + Create School
          </button>
        </div>
      </div>

      {error && <div className="sa-error">{error}</div>}

      <UpcomingCarpoolsPanel
        runs={upcomingCarpools}
        loading={upcomingLoading}
        error={upcomingError}
        schoolCount={upcomingSchoolCount}
        navigate={navigate}
      />

      <MasterSearchPanel token={token} navigate={navigate} />

      <PlatformStatsOverview token={token} />

      {schools.length === 0 ? (
        <div className="sa-card sa-empty">
          No schools yet. Create your first school to get started.
        </div>
      ) : (
        <div className="sa-card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="sa-table">
            <thead>
              <tr>
                <th>School Name</th>
                <th>Nickname</th>
                <th>City, State</th>
                <th>Type</th>
                <th>Status</th>
                <th>Students</th>
                <th>Parents</th>
                <th>Staff</th>
              </tr>
            </thead>
            <tbody>
              {schools.map((s) => (
                <tr
                  key={s.id}
                  className="clickable"
                  onClick={() => navigate('school-dashboard', s.id)}
                >
                  <td style={{ fontWeight: 600 }}>{s.legal_name}</td>
                  <td>{s.school_nickname}</td>
                  <td>{s.city}, {s.state}</td>
                  <td style={{ fontSize: 12 }}>{s.type?.replace(/_/g, ' ')}</td>
                  <td>
                    <span className={`sa-badge ${STATUS_CLASS[s.is_active] || ''}`}>
                      {s.is_active}
                    </span>
                  </td>
                  <td>{s.student_count}</td>
                  <td>{s.parent_count}</td>
                  <td>{s.staff_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
